/*
 * Configurador de Luces — lógica autocontenida (Custom Element <light-configurator>).
 * Réplica del configurador Next.js (estado, validación, animación de paso,
 * navegación por hints de scroll, y compra vía redirect a /products/<handle>).
 * No depende de ningún framework ni de JS global del tema.
 */
(function () {
  "use strict";

  /* ---------------- Iconos (SVG inline, sin dependencias externas) ---------------- */
  var ICON_ATTRS =
    'class="lc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';

  var ICONS = {
    hexagon: '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><path d="M12 2l8.5 5v10L12 22l-8.5-5V7Z"/></svg>',
    sun:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><circle cx="12" cy="12" r="4"/>' +
      '<path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.8 4.8l1.7 1.7M17.5 17.5l1.7 1.7M4.8 19.2l1.7-1.7M17.5 6.5l1.7-1.7" stroke-width="1.5"/></svg>',
    boxes:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.6"><path d="M8 3.5 4 5.7v4.3l4 2.2 4-2.2V5.7Z"/>' +
      '<path d="M16 10.5l-4 2.2v4.3l4 2.2 4-2.2v-4.3Z"/><path d="M8 10.5l-4 2.2v4.3l4 2.2 4-2.2v-4.3Z"/></svg>',
    wrench:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><path d="M14.7 6.3a4 4 0 1 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2-2Z"/></svg>',
    shieldCheck:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><path d="M12 2l8 3.5v6c0 5-3.5 8.5-8 10.5-4.5-2-8-5.5-8-10.5v-6Z"/>' +
      '<polyline points="8.5 12 11 14.5 15.5 9.5"/></svg>',
    check: '<svg ' + ICON_ATTRS + ' stroke-width="3"><polyline points="4 12 9 17 20 6"/></svg>',
    chevronLeft: '<svg ' + ICON_ATTRS + ' stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>',
    chevronRight: '<svg ' + ICON_ATTRS + ' stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>',
    arrowLeft:
      '<svg ' + ICON_ATTRS + ' stroke-width="2.25"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>',
    arrowRight:
      '<svg ' + ICON_ATTRS + ' stroke-width="2.25"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    shoppingBag:
      '<svg ' + ICON_ATTRS + ' stroke-width="2.25"><path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    alertCircle:
      '<svg ' + ICON_ATTRS + ' stroke-width="2.25"><circle cx="12" cy="12" r="9"/><line x1="12" y1="7.5" x2="12" y2="13"/>' +
      '<circle cx="12" cy="16.5" r="0.9" fill="currentColor" stroke="none"/></svg>',
    checkCircle2:
      '<svg ' + ICON_ATTRS + ' stroke-width="2.25"><circle cx="12" cy="12" r="9"/><polyline points="8 12.5 11 15.5 16 9"/></svg>',
    imageOff:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M3 3l18 18"/><path d="M21 15V5a2 2 0 0 0-2-2H8"/>' +
      '<path d="M3 8v11a2 2 0 0 0 2 2h13"/><circle cx="9" cy="9" r="1.5"/></svg>',
    image:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><rect x="3" y="4" width="18" height="16" rx="2"/>' +
      '<circle cx="8.5" cy="9.5" r="1.5"/><path d="M21 15l-5-5-9 9"/></svg>',
    clock: '<svg ' + ICON_ATTRS + ' stroke-width="2"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 16 14"/></svg>',
    gauge:
      '<svg ' + ICON_ATTRS + ' stroke-width="2"><path d="M4.5 17a8 8 0 1 1 15 0"/><line x1="12" y1="13" x2="15.5" y2="9"/>' +
      '<circle cx="12" cy="13" r="1" fill="currentColor" stroke="none"/></svg>',
    users:
      '<svg ' + ICON_ATTRS + ' stroke-width="2"><circle cx="9" cy="8" r="3"/><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5"/>' +
      '<path d="M16 8.3a2.6 2.6 0 1 1 0 5.1"/><path d="M18.5 14.6c2 .5 3.5 2.3 3.5 5"/></svg>',
    ladder:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/>' +
      '<line x1="7" y1="7" x2="17" y2="7"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="7" y1="17" x2="17" y2="17"/></svg>',
    drill:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><rect x="3" y="10" width="10" height="6" rx="1.5"/>' +
      '<path d="M13 12h3l3-2v6l-3-2h-3"/><line x1="19" y1="13" x2="22" y2="13"/></svg>',
    ruler:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><rect x="2.5" y="9" width="19" height="6" rx="1"/>' +
      '<line x1="6" y1="9" x2="6" y2="12"/><line x1="9.5" y1="9" x2="9.5" y2="12"/><line x1="13" y1="9" x2="13" y2="13"/>' +
      '<line x1="16.5" y1="9" x2="16.5" y2="12"/></svg>',
    pencilLine:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><path d="M12 20h9"/>' +
      '<path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>',
    package:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><path d="M21 8l-9-5-9 5 9 5 9-5Z"/>' +
      '<path d="M3 8v8l9 5 9-5V8"/><line x1="12" y1="13" x2="12" y2="21"/></svg>',
    cable:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M2.5 14.5c0-3 2-5 5-5s4.5-1.5 4.5-4"/>' +
      '<rect x="13" y="8.5" width="6" height="7" rx="1.5"/><path d="M19.5 10.25h2.2M19.5 13.75h2.2" stroke-width="1.5"/></svg>',
    zap: '<svg ' + ICON_ATTRS + ' stroke-width="1.75" fill="currentColor" stroke="none"><polygon points="13 2 3 14 11 14 9 22 21 10 13 10 13 2"/></svg>',
    truck:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.75"><path d="M2 6h11v9H2Z"/><path d="M13 9h4l3 3v3h-7Z"/>' +
      '<circle cx="6.5" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    /* Iconos exactos del kit, portados 1:1 desde components/icons/configurator/*.tsx */
    tubeLed:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><rect x="1.75" y="9" width="20.5" height="6" rx="3"/>' +
      '<path d="M7 10.5v3M12 10.5v3M17 10.5v3" stroke-width="1.25"/></svg>',
    unionV:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M12 17 L5.5 6.5"/><path d="M12 17 L18.5 6.5"/>' +
      '<circle cx="12" cy="17" r="1.6" fill="currentColor" stroke="none"/><circle cx="5.5" cy="6" r="1.9"/>' +
      '<circle cx="18.5" cy="6" r="1.9"/></svg>',
    unionY:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M12 13 L6.5 5.5"/><path d="M12 13 L17.5 5.5"/>' +
      '<path d="M12 13 L12 20"/><circle cx="12" cy="13" r="1.6" fill="currentColor" stroke="none"/>' +
      '<circle cx="6.5" cy="5" r="1.9"/><circle cx="17.5" cy="5" r="1.9"/><circle cx="12" cy="20.5" r="1.9"/></svg>',
    powerCable:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M2.5 14.5c0-3 2-5 5-5s4.5-1.5 4.5-4"/>' +
      '<rect x="13" y="8.5" width="6" height="7" rx="1.5"/><path d="M19.5 10.25h2.2M19.5 13.75h2.2" stroke-width="1.5"/></svg>',
    manual:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M12 6.5c-1.8-1.3-4.6-1.8-7-1.3a1 1 0 0 0-.8 1v12a1 1 0 0 0 1.2 1c2.2-.4 4.7 0 6.6 1.3"/>' +
      '<path d="M12 6.5c1.8-1.3 4.6-1.8 7-1.3a1 1 0 0 1 .8 1v12a1 1 0 0 1-1.2 1c-2.2-.4-4.7 0-6.6 1.3"/>' +
      '<path d="M12 6.5v13.8"/><path d="M6.3 9.3h3M6.3 12h3M14.7 9.3h3M14.7 12h3" stroke-width="1.25"/></svg>',
    screw:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><circle cx="12" cy="5" r="3"/><path d="M9.3 5h5.4M12 2.3v5.4" stroke-width="1.25"/>' +
      '<path d="M12 8v11.5"/><path d="M9.6 10.5h4.8M9.6 13h4.8M9.6 15.5h4.8M9.6 18h4.8" stroke-width="1.15"/>' +
      '<path d="M12 19.5 10.3 21.5h3.4Z"/></svg>',
    anchor:
      '<svg ' + ICON_ATTRS + ' stroke-width="1.5"><path d="M2.5 5.5h19"/>' +
      '<path d="M3.5 2.5 2 5.5M8 2.5 6.5 5.5M12.5 2.5 11 5.5M17 2.5 15.5 5.5M21.5 2.5 20 5.5" stroke-width="1.15"/>' +
      '<path d="M7.5 5.5 9 20l3 2 3-2 1.5-14.5Z"/><path d="M8.4 9.5h7.2M8.9 13h6.2M9.5 16.5h5" stroke-width="1.25"/></svg>'
  };

  function icon(name) {
    return ICONS[name] || "";
  }

  var STEP_ICON_NAMES = { 1: "hexagon", 2: "sun", 3: "boxes", 4: "wrench", 5: "shieldCheck" };

  /* ---------------- Helpers ---------------- */
  function formatCOP(value) {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      maximumFractionDigits: 0
    }).format(value);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }

  function formatStr(template, vars) {
    if (!template) return "";
    return template.replace(/{{\s*(\w+)\s*}}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(vars || {}, key) ? vars[key] : match;
    });
  }

  function byId(scope, id) {
    return scope.querySelector('[data-lc-id="' + id + '"]');
  }

  /* ---------------- Custom Element ---------------- */
  class LightConfigurator extends HTMLElement {}

  LightConfigurator.prototype.connectedCallback = function () {
    var dataNode = this.querySelector('script[data-lc="catalog"]');
    var stringsNode = this.querySelector('script[data-lc="strings"]');
    this.data = JSON.parse(dataNode.textContent);
    this.strings = JSON.parse(stringsNode.textContent);

    var firstProduct = this.data.products[0];

    this.state = {
      currentStep: 1,
      selectedProductId: firstProduct ? firstProduct.id : null,
      selectedTonalityId: null,
      previewIndex: 0
    };
    this.purchaseConfirmed = false;
    this.purchaseError = null;
    this._prevStep = null;
    this._boundClick = this.handleClick.bind(this);
    this.addEventListener("click", this._boundClick);
    this.render();
  };

  LightConfigurator.prototype.disconnectedCallback = function () {
    this.removeEventListener("click", this._boundClick);
  };

  LightConfigurator.prototype.getSelectedProduct = function () {
    var id = this.state.selectedProductId;
    if (!id) return null;
    var products = this.data.products;
    for (var i = 0; i < products.length; i++) {
      if (products[i].id === id) return products[i];
    }
    return null;
  };

  LightConfigurator.prototype.getSelectedTonality = function () {
    var id = this.state.selectedTonalityId;
    if (!id) return null;
    var tonalities = this.data.tonalities;
    for (var i = 0; i < tonalities.length; i++) {
      if (tonalities[i].id === id) return tonalities[i];
    }
    return null;
  };

  LightConfigurator.prototype.getValidation = function () {
    if (this.state.currentStep === 1) {
      return {
        canProceed: this.state.selectedProductId !== null,
        message: this.strings.messages.select_design
      };
    }
    if (this.state.currentStep === 2) {
      return {
        canProceed: this.state.selectedTonalityId !== null,
        message: this.strings.messages.select_tonality
      };
    }
    return { canProceed: true, message: null };
  };

  /* ---------------- Acciones ---------------- */
  LightConfigurator.prototype.handleClick = function (event) {
    var el = event.target.closest("[data-lc-action]");
    if (!el || !this.contains(el)) return;
    var action = el.getAttribute("data-lc-action");

    if (action === "select-product") {
      this.state.selectedProductId = el.getAttribute("data-id");
      this.state.previewIndex = 0;
      this.render();
      return;
    }
    if (action === "select-tonality") {
      this.state.selectedTonalityId = el.getAttribute("data-id");
      this.render();
      return;
    }
    if (action === "prev-image" || action === "next-image") {
      var product = this.getSelectedProduct();
      if (!product) return;
      var total = product.images.length;
      if (total <= 1) return;
      if (action === "prev-image") {
        this.state.previewIndex = (this.state.previewIndex - 1 + total) % total;
      } else {
        this.state.previewIndex = (this.state.previewIndex + 1) % total;
      }
      this.render();
      return;
    }
    if (action === "back") {
      this.purchaseConfirmed = false;
      this.purchaseError = null;
      this.state.currentStep = Math.max(1, this.state.currentStep - 1);
      this.render();
      return;
    }
    if (action === "next") {
      if (!this.getValidation().canProceed) return;
      this.purchaseConfirmed = false;
      this.purchaseError = null;
      this.state.currentStep = Math.min(5, this.state.currentStep + 1);
      this.render();
      return;
    }
    if (action === "purchase") {
      this.handlePurchase();
      return;
    }
  };

  LightConfigurator.prototype.getReleasitVariantId = function () {
    var product = this.getSelectedProduct();
    var tonality = this.getSelectedTonality();
    if (!product || !tonality) return null;
    var mapping = this.data.shopifyProductMap[product.id];
    return (mapping && mapping.variantsByTonality[tonality.id]) || null;
  };

  LightConfigurator.prototype.handlePurchase = function () {
    var product = this.getSelectedProduct();
    var tonality = this.getSelectedTonality();
    var messages = this.strings.messages;

    if (!product) {
      this.purchaseError = messages.purchase_needs_design;
      this.render();
      return;
    }
    if (!tonality) {
      this.purchaseError = messages.purchase_needs_tonality;
      this.render();
      return;
    }
    this.purchaseError = null;

    // Este botón solo se renderiza (ver renderNav) cuando el kit todavía NO
    // tiene un variant ID real mapeado en shopifyProductMap. Cuando sí lo
    // tiene, este botón no aparece — en su lugar se muestra el hook real de
    // Releasit (ver syncReleasitHook), que es lo que el usuario debe pulsar
    // para abrir el formulario COD real. No hay redirect a /products/ ni a
    // /cart en ningún caso.
    this.purchaseConfirmed = true;
    this.render();
  };

  /* ---------------- Integración real de Releasit (Paso 5) ---------------- */
  LightConfigurator.prototype.syncReleasitFields = function () {
    var product = this.getSelectedProduct();
    var tonality = this.getSelectedTonality();
    var variantId = this.getReleasitVariantId();

    var fieldVariant = document.getElementById("lc-releasit-variant-id");
    var fieldDesign = document.getElementById("lc-releasit-property-design");
    var fieldTone = document.getElementById("lc-releasit-property-tone");
    var fieldProduct = document.getElementById("lc-releasit-property-product");
    var fieldHandle = document.getElementById("lc-releasit-property-handle");
    if (!fieldVariant) return;

    var mapping = product && this.data.shopifyProductMap[product.id];

    fieldVariant.value = variantId || "";
    fieldDesign.value = product ? product.shapeLabel : "";
    fieldTone.value = tonality ? tonality.name + " · " + tonality.kelvin + "K" : "";
    fieldProduct.value = product ? product.name : "";
    fieldHandle.value = mapping ? mapping.handle : "";
  };

  LightConfigurator.prototype.syncReleasitHook = function () {
    var holder = document.getElementById("lc-releasit-holder");
    if (!holder) return;

    // Nunca tocamos #lc-releasit-button-hook directamente: Releasit lo
    // reconoce por su clase y lo reemplaza por su botón/formulario real (no
    // lo rellena por dentro), así que ese nodo puede dejar de existir en
    // cualquier momento. Por eso movemos el contenedor padre COMPLETO
    // (#lc-releasit-holder, que Releasit no toca) — funciona sin importar
    // qué haga Releasit con el hook adentro. El rescate hacia afuera (para
    // que no se destruya en el próximo innerHTML) ocurre al inicio de
    // render(); aquí solo decidimos si corresponde traerlo de vuelta al
    // slot del Paso 5.
    var variantId = this.getReleasitVariantId();
    var slot = this.querySelector('[data-lc-id="releasit-slot"]');
    if (this.state.currentStep === 5 && variantId && slot) {
      slot.appendChild(holder);
    }
  };

  /* ---------------- Render ---------------- */
  LightConfigurator.prototype.render = function () {
    var stepChanged = this._prevStep !== this.state.currentStep;
    this._prevStep = this.state.currentStep;

    // Cada render() reemplaza innerHTML por completo, así que los
    // contenedores con scroll propio (la columna del paso, la grilla de
    // productos) se destruyen y los nuevos siempre nacen con scrollTop = 0.
    // Eso es correcto al CAMBIAR de paso (queremos empezar arriba), pero es
    // lo que hacía "recargar y saltar al inicio" al solo seleccionar un
    // producto/tonalidad dentro del MISMO paso. Por eso guardamos y
    // restauramos el scroll únicamente cuando el paso no cambió.
    var prevStepColScroll = 0;
    var prevProductGridScroll = 0;
    var prevWindowScrollY = window.scrollY;
    if (!stepChanged) {
      var prevStepCol = this.querySelector('[data-lc-id="step-col"]');
      if (prevStepCol) prevStepColScroll = prevStepCol.scrollTop;
      var prevProductGrid = this.querySelector('[data-lc-id="product-grid"]');
      if (prevProductGrid) prevProductGridScroll = prevProductGrid.scrollTop;
    }

    // Rescatar el holder de Releasit ANTES de reemplazar innerHTML: si el
    // render anterior lo dejó dentro del componente (Paso 5), hay que
    // sacarlo primero o el innerHTML de abajo lo destruiría junto con
    // cualquier cosa que Releasit ya haya inicializado ahí dentro.
    var releasitHolder = document.getElementById("lc-releasit-holder");
    if (releasitHolder && this.contains(releasitHolder)) {
      this.insertAdjacentElement("afterend", releasitHolder);
    }

    this.innerHTML =
      '<div class="lc-app">' +
      this.renderHeader() +
      '<div class="lc-main">' +
      '<div class="lc-preview-col">' +
      this.renderPreview() +
      "</div>" +
      '<div class="lc-step-col' +
      (stepChanged ? " lc-step-fade" : "") +
      '" data-lc-id="step-col">' +
      this.renderStepContent() +
      "</div>" +
      "</div>" +
      this.renderNav() +
      "</div>";

    if (!stepChanged) {
      var newStepCol = this.querySelector('[data-lc-id="step-col"]');
      if (newStepCol) newStepCol.scrollTop = prevStepColScroll;
      var newProductGrid = this.querySelector('[data-lc-id="product-grid"]');
      if (newProductGrid) newProductGrid.scrollTop = prevProductGridScroll;
      window.scrollTo(window.scrollX, prevWindowScrollY);
    }

    this.setupProgressHints();
    this.syncReleasitFields();
    this.syncReleasitHook();
  };

  LightConfigurator.prototype.renderHeader = function () {
    var strings = this.strings;
    var currentStep = this.state.currentStep;
    var stepKeys = [1, 2, 3, 4, 5];

    var items = stepKeys
      .map(function (step) {
        var meta = strings.steps[String(step)];
        var isCurrent = step === currentStep;
        var isCompleted = step < currentStep;
        return (
          '<li class="lc-progress-item" data-step="' +
          step +
          '" data-current="' +
          isCurrent +
          '" data-completed="' +
          isCompleted +
          '">' +
          '<span class="lc-progress-icon-wrap">' +
          icon(STEP_ICON_NAMES[step]) +
          (isCompleted ? '<span class="lc-progress-check">' + icon("check") + "</span>" : "") +
          "</span>" +
          '<span class="lc-progress-label">' +
          step +
          ". " +
          escapeHtml(meta.title) +
          "</span>" +
          '<span class="lc-progress-bar"></span>' +
          "</li>"
        );
      })
      .join("");

    return (
      '<header class="lc-header">' +
      '<div class="lc-logo"><img src="' +
      this.data.logoUrl +
      '" alt="' +
      escapeHtml(strings.brand_alt) +
      '"></div>' +
      '<div class="lc-header-divider"></div>' +
      '<nav class="lc-progress" aria-label="Progreso del configurador" data-lc-id="progress">' +
      '<ol class="lc-progress-scroller lc-scroll-gold" data-lc-id="progress-scroller">' +
      items +
      "</ol>" +
      '<div class="lc-progress-hint lc-progress-hint--left" data-lc-id="hint-left" hidden>' +
      icon("chevronLeft") +
      "</div>" +
      '<div class="lc-progress-hint lc-progress-hint--right" data-lc-id="hint-right" hidden>' +
      icon("chevronRight") +
      "</div>" +
      "</nav>" +
      "</header>"
    );
  };

  LightConfigurator.prototype.renderPreview = function () {
    var product = this.getSelectedProduct();
    var tonality = this.getSelectedTonality();
    var strings = this.strings;

    if (!product) {
      return (
        '<div class="lc-preview"><div class="lc-preview-frame"><div class="lc-preview-empty">' +
        icon("image") +
        "<p>" +
        escapeHtml(strings.preview.empty) +
        "</p></div></div></div>"
      );
    }

    var images = product.images || [];
    var total = images.length;
    var safeIndex = total > 0 ? Math.min(this.state.previewIndex, total - 1) : 0;
    var hasMultiple = total > 1;

    var media;
    if (total > 0) {
      var tint = tonality
        ? '<div class="lc-preview-tint" style="background: radial-gradient(120% 100% at 30% 20%, ' +
          tonality.swatchFrom +
          ", " +
          tonality.swatchTo +
          ' 70%)"></div>'
        : "";
      var arrows = hasMultiple
        ? '<button type="button" class="lc-preview-arrow lc-preview-arrow--prev" data-lc-action="prev-image" aria-label="' +
          escapeHtml(strings.preview.previous_image) +
          '">' +
          icon("chevronLeft") +
          "</button>" +
          '<button type="button" class="lc-preview-arrow lc-preview-arrow--next" data-lc-action="next-image" aria-label="' +
          escapeHtml(strings.preview.next_image) +
          '">' +
          icon("chevronRight") +
          "</button>" +
          '<span class="lc-preview-counter">' +
          formatStr(strings.preview.counter, { current: safeIndex + 1, total: total }) +
          "</span>"
        : "";
      media =
        '<img src="' +
        images[safeIndex] +
        '" alt="' +
        escapeHtml(product.name) +
        '">' +
        tint +
        arrows;
    } else {
      media =
        '<div class="lc-preview-fallback" role="img" aria-label="' +
        escapeHtml(product.name) +
        '">' +
        icon("imageOff") +
        "<span>" +
        escapeHtml(product.name) +
        "</span></div>";
    }

    return '<div class="lc-preview"><div class="lc-preview-frame">' + media + "</div></div>";
  };

  LightConfigurator.prototype.renderStepContent = function () {
    var step = this.state.currentStep;
    if (step === 1) return this.renderStep1();
    if (step === 2) return this.renderStep2();
    if (step === 3) return this.renderStep3();
    if (step === 4) return this.renderStep4();
    return this.renderStep5();
  };

  LightConfigurator.prototype.renderStep1 = function () {
    var data = this.data;
    var strings = this.strings;
    var selectedProduct = this.getSelectedProduct();
    var selectedId = this.state.selectedProductId;

    var sizingProduct = data.products.reduce(function (a, b) {
      var scoreA = a.name.length + a.dimensions.label.length;
      var scoreB = b.name.length + b.dimensions.label.length;
      return scoreB > scoreA ? b : a;
    });
    var summaryProduct = selectedProduct || sizingProduct;
    var pc = strings.product_card;

    var cards = data.products
      .map(function (product) {
        var selected = product.id === selectedId;
        var thumbMarkup = product.thumbnail
          ? '<img src="' + product.thumbnail + '" alt="' + escapeHtml(product.name) + '">'
          : '<div class="lc-preview-fallback" style="position:absolute;inset:0;">' +
            icon("imageOff") +
            "<span>" +
            escapeHtml(product.name) +
            "</span></div>";
        return (
          '<button type="button" class="lc-card" data-lc-action="select-product" data-id="' +
          product.id +
          '" data-selected="' +
          selected +
          '" aria-pressed="' +
          selected +
          '">' +
          '<div class="lc-card-media">' +
          thumbMarkup +
          (selected ? '<span class="lc-card-check">' + icon("checkCircle2") + "</span>" : "") +
          "</div>" +
          '<div class="lc-card-body">' +
          '<p class="lc-card-name">' +
          escapeHtml(product.name) +
          "</p>" +
          '<span class="lc-card-tag">' +
          icon("hexagon") +
          formatStr(pc.hexagons_and_shape, { count: product.hexagonCount, shape: escapeHtml(product.shapeLabel) }) +
          "</span>" +
          '<p class="lc-card-dims">' +
          escapeHtml(product.dimensions.label) +
          "</p>" +
          '<p class="lc-card-price">' +
          formatCOP(product.price) +
          "</p>" +
          "</div>" +
          "</button>"
        );
      })
      .join("");

    var meta = strings.steps["1"];

    return (
      '<div class="lc-selection-head">' +
      '<div class="lc-selection-head-intro" data-hidden="' +
      !!selectedProduct +
      '">' +
      '<h2 class="lc-step-title">' +
      escapeHtml(meta.title) +
      "</h2>" +
      '<p class="lc-step-subtitle">' +
      escapeHtml(meta.subtitle) +
      "</p>" +
      "</div>" +
      '<div class="lc-selection-head-summary" data-hidden="' +
      !selectedProduct +
      '">' +
      '<p class="lc-selection-summary-name">' +
      escapeHtml(summaryProduct.name) +
      "</p>" +
      '<p class="lc-selection-summary-dims">' +
      escapeHtml(summaryProduct.dimensions.label) +
      "</p>" +
      '<div class="lc-badge-row">' +
      '<span class="lc-badge">' +
      icon("hexagon") +
      formatStr(pc.hexagons_and_shape, { count: summaryProduct.hexagonCount, shape: escapeHtml(summaryProduct.shapeLabel) }) +
      "</span>" +
      '<span class="lc-badge">' +
      icon("gauge") +
      formatStr(pc.power, { watts: summaryProduct.powerWatts }) +
      "</span>" +
      "</div>" +
      '<p class="lc-selection-summary-price lc-gold-metallic">' +
      formatCOP(summaryProduct.price) +
      "</p>" +
      "</div>" +
      "</div>" +
      '<div class="lc-product-grid lc-scroll-gold" data-lc-id="product-grid">' +
      cards +
      "</div>"
    );
  };

  LightConfigurator.prototype.renderStep2 = function () {
    var strings = this.strings;
    var meta = strings.steps["2"];
    var selectedId = this.state.selectedTonalityId;

    var options = this.data.tonalities
      .map(function (tonality) {
        var selected = tonality.id === selectedId;
        return (
          '<button type="button" class="lc-tonality-option" data-lc-action="select-tonality" data-id="' +
          tonality.id +
          '" data-selected="' +
          selected +
          '" aria-pressed="' +
          selected +
          '">' +
          '<span class="lc-tonality-swatch" style="background: radial-gradient(circle at 35% 30%, ' +
          tonality.swatchFrom +
          ", " +
          tonality.swatchTo +
          ' 75%)"></span>' +
          '<span class="lc-tonality-text">' +
          '<span class="lc-tonality-name">' +
          escapeHtml(tonality.name) +
          " · " +
          tonality.kelvin +
          "K</span>" +
          '<span class="lc-tonality-desc">' +
          escapeHtml(tonality.description) +
          "</span>" +
          "</span>" +
          (selected
            ? '<span class="lc-tonality-check">' + icon("checkCircle2") + "</span>"
            : '<span class="lc-tonality-unchecked"></span>') +
          "</button>"
        );
      })
      .join("");

    return (
      '<h2 class="lc-step-title">' +
      escapeHtml(meta.title) +
      "</h2>" +
      '<p class="lc-step-subtitle">' +
      escapeHtml(meta.subtitle) +
      "</p>" +
      '<div class="lc-tonality-list">' +
      options +
      "</div>"
    );
  };

  LightConfigurator.prototype.renderStep3 = function () {
    var strings = this.strings;
    var data = this.data;
    var meta = strings.steps["3"];
    var product = this.getSelectedProduct();

    var subtitle = product
      ? formatStr(meta.subtitle_with_product, { product_name: escapeHtml(product.name), shape_label: escapeHtml(product.shapeLabel) })
      : meta.subtitle_empty;

    var highlights = data.highlights
      .map(function (text) {
        return '<li class="lc-highlight-item">' + icon("check") + escapeHtml(text) + "</li>";
      })
      .join("");

    var kitGrid = "";
    if (product) {
      kitGrid =
        '<div class="lc-kit-container"><div class="lc-kit-grid">' +
        product.kitContents
          .map(function (entry) {
            var item = data.kitItems[entry.itemId];
            if (!item) return "";
            return (
              '<div class="lc-kit-item">' +
              icon(item.icon) +
              '<div class="lc-kit-item-body"><div class="lc-kit-item-row">' +
              '<p class="lc-kit-item-name">' +
              escapeHtml(item.name) +
              "</p>" +
              '<span class="lc-kit-item-qty">×' +
              entry.quantity +
              "</span></div>" +
              '<p class="lc-kit-item-desc">' +
              escapeHtml(item.description) +
              "</p></div>" +
              "</div>"
            );
          })
          .join("") +
        "</div></div>";
    }

    return (
      '<h2 class="lc-step-title">' +
      escapeHtml(meta.title) +
      "</h2>" +
      '<p class="lc-step-subtitle">' +
      subtitle +
      "</p>" +
      '<ul class="lc-highlight-list">' +
      highlights +
      "</ul>" +
      kitGrid
    );
  };

  LightConfigurator.prototype.renderStep4 = function () {
    var strings = this.strings;
    var installation = this.data.installation;
    var meta = strings.steps["4"];
    var inst = strings.installation;

    var chips =
      '<span class="lc-chip">' +
      icon("clock") +
      installation.estimatedTime +
      "</span>" +
      '<span class="lc-chip">' +
      icon("gauge") +
      installation.difficulty +
      "</span>" +
      '<span class="lc-chip">' +
      icon("users") +
      installation.recommendedPeople +
      "</span>";

    var tools = installation.tools
      .map(function (tool) {
        return (
          '<div class="lc-tool-card">' +
          icon(tool.icon) +
          '<p class="lc-tool-name">' +
          escapeHtml(tool.name) +
          "</p>" +
          '<p class="lc-tool-desc">' +
          escapeHtml(tool.description) +
          "</p></div>"
        );
      })
      .join("");

    var steps = installation.steps
      .map(function (step) {
        return (
          '<li class="lc-install-step">' +
          '<div class="lc-install-step-icon">' +
          icon(step.icon) +
          "</div>" +
          "<div><p class=\"lc-install-step-order\">" +
          formatStr(inst.step_label, { number: step.order }) +
          "</p>" +
          '<p class="lc-install-step-title">' +
          escapeHtml(step.title) +
          "</p>" +
          '<p class="lc-install-step-desc">' +
          escapeHtml(step.description) +
          "</p></div>" +
          "</li>"
        );
      })
      .join("");

    return (
      '<h2 class="lc-step-title">' +
      escapeHtml(meta.title) +
      "</h2>" +
      '<p class="lc-step-subtitle">' +
      escapeHtml(installation.tagline) +
      "</p>" +
      '<div class="lc-chip-row">' +
      chips +
      "</div>" +
      '<h3 class="lc-subheading">' +
      escapeHtml(inst.need_title) +
      "</h3>" +
      '<p class="lc-subheading-note">' +
      escapeHtml(inst.need_subtitle) +
      "</p>" +
      '<div class="lc-tools-grid">' +
      tools +
      "</div>" +
      '<h3 class="lc-subheading">' +
      escapeHtml(inst.process_title) +
      "</h3>" +
      '<ol class="lc-install-steps">' +
      steps +
      "</ol>"
    );
  };

  LightConfigurator.prototype.renderStep5 = function () {
    var strings = this.strings;
    var data = this.data;
    var meta = strings.steps["5"];
    var product = this.getSelectedProduct();
    var tonality = this.getSelectedTonality();
    var summary = strings.summary;

    var warrantyShipping =
      '<div class="lc-warranty-grid">' +
      '<div class="lc-info-card"><div class="lc-info-card-head">' +
      '<span class="lc-info-card-icon">' +
      icon("truck") +
      "</span>" +
      '<p class="lc-info-card-title">' +
      escapeHtml(data.shipping.title) +
      "</p></div>" +
      '<div class="lc-info-card-main"><span class="lc-info-card-value">' +
      escapeHtml(data.shipping.cost) +
      '</span><span class="lc-info-card-aux">' +
      escapeHtml(data.shipping.estimatedDays) +
      "</span></div>" +
      '<p class="lc-info-card-note">' +
      escapeHtml(data.shipping.note) +
      "</p></div>" +
      '<div class="lc-info-card"><div class="lc-info-card-head">' +
      '<span class="lc-info-card-icon">' +
      icon("shieldCheck") +
      "</span>" +
      '<p class="lc-info-card-title">' +
      escapeHtml(data.warranty.title) +
      "</p></div>" +
      '<div class="lc-info-card-main"><span class="lc-info-card-value">' +
      (data.warranty.included ? escapeHtml(summary.included) : escapeHtml(summary.not_included)) +
      "</span></div>" +
      '<p class="lc-info-card-note">' +
      escapeHtml(data.warranty.description) +
      "</p></div>" +
      "</div>";

    var summaryCard = "";
    if (product) {
      summaryCard =
        '<div class="lc-summary"><div class="lc-summary-head">' +
        '<div class="lc-summary-thumb">' +
        (product.thumbnail ? '<img src="' + product.thumbnail + '" alt="' + escapeHtml(product.name) + '">' : "") +
        "</div>" +
        '<div class="lc-summary-info">' +
        '<p class="lc-summary-name">' +
        escapeHtml(product.name) +
        "</p>" +
        '<p class="lc-summary-line">' +
        escapeHtml(product.dimensions.label) +
        "</p>" +
        (tonality
          ? '<p class="lc-summary-line">' + escapeHtml(tonality.name) + " · " + tonality.kelvin + "K</p>"
          : "") +
        "</div>" +
        '<p class="lc-summary-price lc-gold-metallic">' +
        formatCOP(product.price) +
        "</p>" +
        "</div>" +
        '<div class="lc-summary-dl">' +
        '<div><p class="lc-summary-dt">' +
        escapeHtml(summary.shipping_label) +
        '</p><p class="lc-summary-dd">' +
        escapeHtml(data.shipping.cost) +
        "</p></div>" +
        '<div><p class="lc-summary-dt">' +
        escapeHtml(summary.warranty_label) +
        '</p><p class="lc-summary-dd">' +
        data.warranty.years +
        " " +
        escapeHtml(summary.years_suffix) +
        "</p></div>" +
        "</div>" +
        '<p class="lc-summary-footnote">' +
        escapeHtml(summary.no_extra_costs) +
        "</p>" +
        "</div>";
    }

    var banners = "";
    if (this.purchaseConfirmed) {
      banners +=
        '<div class="lc-banner lc-banner--success">' +
        icon("checkCircle2") +
        escapeHtml(strings.messages.order_confirmed) +
        "</div>";
    }
    if (this.purchaseError) {
      banners += '<div class="lc-banner">' + icon("alertCircle") + escapeHtml(this.purchaseError) + "</div>";
    }

    return (
      '<h2 class="lc-step-title">' +
      escapeHtml(meta.title) +
      "</h2>" +
      '<p class="lc-step-subtitle">' +
      escapeHtml(meta.subtitle) +
      "</p>" +
      warrantyShipping +
      summaryCard +
      banners
    );
  };

  LightConfigurator.prototype.renderNav = function () {
    var strings = this.strings;
    var step = this.state.currentStep;
    var isLastStep = step === 5;
    var validation = this.getValidation();

    var primaryButton;
    if (isLastStep) {
      // Si el kit + tonalidad elegidos ya tienen un variant ID real
      // (shopifyProductMap), no renderizamos ningún botón propio: dejamos un
      // slot vacío en el mismo lugar donde iría "Siguiente"/"Realizar
      // compra" — ahí es donde syncReleasitHook() reubica el contenedor
      // real de Releasit. Si todavía no hay mapeo real para ese kit,
      // mantenemos el botón propio con el aviso de demo de siempre.
      primaryButton = this.getReleasitVariantId()
        ? '<div class="lc-nav-next-slot" data-lc-id="releasit-slot"></div>'
        : '<button type="button" class="lc-btn-primary" data-lc-action="purchase">' +
          icon("shoppingBag") +
          escapeHtml(strings.nav.purchase) +
          "</button>";
    } else {
      primaryButton =
        '<button type="button" class="lc-btn-primary" data-lc-action="next"' +
        (validation.canProceed ? "" : " disabled") +
        ">" +
        escapeHtml(strings.nav.next) +
        icon("arrowRight") +
        "</button>";
    }

    var showValidation = !validation.canProceed && validation.message;

    return (
      '<div class="lc-nav">' +
      '<button type="button" class="lc-btn-back" data-lc-action="back"' +
      (step === 1 ? " disabled" : "") +
      ">" +
      icon("arrowLeft") +
      escapeHtml(strings.nav.back) +
      "</button>" +
      '<div class="lc-nav-end">' +
      '<span class="lc-validation" data-hidden="' +
      !showValidation +
      '">' +
      (showValidation ? escapeHtml(validation.message) : "") +
      "</span>" +
      primaryButton +
      "</div>" +
      "</div>"
    );
  };

  /* ---------------- Scroll hints de la barra de pasos ---------------- */
  LightConfigurator.prototype.setupProgressHints = function () {
    var root = this;
    var scroller = byId(this, "progress-scroller");
    var hintLeft = byId(this, "hint-left");
    var hintRight = byId(this, "hint-right");
    if (!scroller) return;

    function updateHints() {
      var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 1;
      var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
      var atStart = scroller.scrollLeft <= 1;
      hintLeft.hidden = !(hasOverflow && !atStart);
      hintRight.hidden = !(hasOverflow && !atEnd);
    }

    updateHints();
    scroller.addEventListener("scroll", updateHints, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(updateHints);
      ro.observe(scroller);
    }

    var activeItem = scroller.querySelector('[data-step="' + root.state.currentStep + '"]');
    if (activeItem) {
      activeItem.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  };

  if (!customElements.get("light-configurator")) {
    customElements.define("light-configurator", LightConfigurator);
  }
})();
